import range from 'lodash/range';
import { cloneElement } from 'react';

import type { FC, ReactElement } from 'react';

export interface SkeletonsProps {
  element: ReactElement;
  amount: number;
}

export const Skeletons: FC<SkeletonsProps> = ({ element, amount }) => (
  <>{range(amount).map(key => cloneElement(element, { key, index: key }))}</>
);
